import { render, staticRenderFns } from "./despatch.vue?vue&type=template&id=15e8e2e2&scoped=true&"
import script from "./despatch.vue?vue&type=script&lang=js&"
export * from "./despatch.vue?vue&type=script&lang=js&"
import style0 from "./despatch.vue?vue&type=style&index=0&id=15e8e2e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e8e2e2",
  null
  
)

export default component.exports